import React from 'react';
import { connect } from 'react-redux';
import {
  followFeedUser,
  unfollowFeedUser,
} from 'common/actions';
import ContainerPlayer from 'common/container-player';
import ContainerSection from 'common/container-section';
import ContainerType from 'common/container-subtype';
import CustomizeProp from 'common/prop-types/customize';
import FeedUserTypes from 'common/feed-user-type';
import TabWrapper from 'components/shared/profile-tabs/tab-wrapper';
import Timeline from 'components/shared/profile-tabs/timeline/timeline';
import DisplayAd from 'components/shared/display-ad';
import ads from '../../../utility/ads';
import DisplayAdModel from '../../../utility/ads/display-ad-model';
import browserDetect from '../../../utility/browser-detect';

// This is purely a dummy component for managing the timeline display
// in a way that takes advantage of our redux store.
// The actual DOM element lives in a partial view on the page, outside
// of the React app.
class AuthorTimelineTab extends React.Component {
  static propTypes = {
    ads: React.PropTypes.object,
    author: React.PropTypes.shape({
      hideDisplayAds: React.PropTypes.bool.isRequired,
      hudlAccountId: React.PropTypes.string.isRequired,
      primaryName: React.PropTypes.string.isRequired,
      profileBannerUri: React.PropTypes.string.isRequired,
      profileUrlBase: React.PropTypes.string.isRequired,
    }).isRequired,
    customize: CustomizeProp.isRequired,
    dispatch: React.PropTypes.func.isRequired,
    feedback: React.PropTypes.shape({
      feedbackEnabled: React.PropTypes.bool.isRequired,
      feedbackSurveyUrl: React.PropTypes.string.isRequired,
      optionSelected: React.PropTypes.bool,
    }).isRequired,
    feedContentItems: React.PropTypes.arrayOf(React.PropTypes.object),
    canDismissFeedItems: React.PropTypes.bool,
    forcePublicView: React.PropTypes.bool,
    presetFilterType: React.PropTypes.number,
    isMobile: React.PropTypes.bool.isRequired,
    onboarding: React.PropTypes.shape({
      isDismissed: React.PropTypes.bool,
      steps: React.PropTypes.arrayOf(React.PropTypes.string),
      currentStep: React.PropTypes.string,
    }).isRequired,
    onChangeTab: React.PropTypes.func.isRequired,
    user: React.PropTypes.shape({
      isPrivilegedUser: React.PropTypes.bool,
      userId: React.PropTypes.string,
    }),
  }

  onFollowUnfollow(feedUserTypeId, feedUserRelatedId, isFollow) {
    const isCurrentProfile = feedUserTypeId === FeedUserTypes.Hudl
      && feedUserRelatedId === this.props.author.hudlAccountId;
    if (isFollow) {
      this.props.dispatch(followFeedUser(feedUserTypeId, feedUserRelatedId, isCurrentProfile));
    } else {
      this.props.dispatch(unfollowFeedUser(feedUserTypeId, feedUserRelatedId, isCurrentProfile));
    }
  }

  render() {
    const authorFeedUser = {
      type: FeedUserTypes.Hudl,
      userId: this.props.author.hudlAccountId,
      feedUserId: {
        type: FeedUserTypes.Hudl,
        relatedId: this.props.author.hudlAccountId,
      },
    };

    const logData = {
      containerSection: ContainerSection.Timeline,
      containerType: ContainerType.Author,
      player: ContainerPlayer.TimelineCard,
    };

    const displayAdModel = new DisplayAdModel('div-gpt-ad-1467399932756-0', 'Display_HudlAccountTimeline_Desktop');
    const isMobile = this.props.isMobile || browserDetect.isModernIPad;
    return (
      <TabWrapper>
        <div className="timeline-tab">
          <div className="left-column">
          </div>
          <Timeline
            ads={this.props.ads}
            currentUserId={this.props.user.userId}
            customize={this.props.customize}
            bannerImage={this.props.author.profileBannerUri}
            feedback={this.props.feedback}
            feedContentItems={this.props.feedContentItems}
            onboarding={this.props.onboarding}
            forcePublicView={this.props.forcePublicView}
            canDismissFeedItems={this.props.canDismissFeedItems}
            presetFilterType={this.props.presetFilterType}
            isMobile={isMobile}
            isPrivilegedUser={!!(this.props.user && this.props.user.isPrivilegedUser)}
            // I don't usually like passing dispatch down, but in this case I'm trying to
            // extend the TimelineTab which can dispatch generic actions (e.g. advance onboarding
            // step or give feedback) while profile-specific tabs can dispatch more context-aware
            // actions
            dispatch={this.props.dispatch}
            feedUser={authorFeedUser}
            logData={logData}
          />
          <div className="right-column">
            {!isMobile && !this.props.author.hideDisplayAds
              ? <DisplayAd
                  id={displayAdModel.getId()}
                  path={displayAdModel.getPath()}
                  sizes={[ads.sizes.MediumRectangle]}
                  adSizeMapping={ads.mappings.all}
              />
              : null}
          </div>
        </div>
      </TabWrapper>
    );
  }
}

function select(state) {
  return state;
}

export default connect(select)(AuthorTimelineTab);
